import { stats } from "@/mocks/press";

const highlights = [
  {
    icon: "ri-film-line",
    title: "Full-service sales",
    text: "International distribution, financing and marketing across every major market.",
  },
  {
    icon: "ri-earth-line",
    title: "120+ territories",
    text: "A trusted network of buyers, broadcasters and streamers worldwide.",
  },
  {
    icon: "ri-stack-line",
    title: "Diverse slate",
    text: "Action, thriller, romance and comedy titles from celebrated filmmakers.",
  },
];

export default function AboutBand() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative w-full aspect-[4/3] overflow-hidden rounded-lg bg-foreground-900">
              <img
                src="https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7Bdf73ec3d-2a79-e511-9487-0e563b5fb261%7D/Screenshot%202025-10-13%20at%203.25.13%E2%80%AFPM_%7B8623bd06-84a8-f011-82a9-0e4a64f8a357%7D.png"
                alt="Voltage Pictures feature film key art"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -right-2 md:right-6 rounded-lg bg-primary-500 text-background-50 px-6 py-5 max-w-[220px]">
              <p className="font-heading font-extrabold text-3xl leading-none">20+</p>
              <p className="mt-1.5 font-label text-[11px] tracking-[0.18em] uppercase text-background-100/90">
                Years of global film sales
              </p>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 font-label text-[11px] tracking-[0.3em] uppercase text-primary-500">
              <span className="w-6 h-px bg-primary-500" />
              About Voltage
            </span>
            <h2 className="mt-3 font-heading font-extrabold uppercase tracking-tight text-foreground-950 text-3xl md:text-5xl leading-[1.02]">
              Built for bold, global cinema
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 max-w-xl leading-relaxed">
              Voltage Pictures produces, finances and licenses commercially driven feature
              films, connecting standout stories and talent with audiences around the world.
              From festival premieres to worldwide releases, we move titles from script to
              screen.
            </p>

            <div className="mt-8 space-y-5">
              {highlights.map((h) => (
                <div key={h.title} className="flex items-start gap-4">
                  <span className="flex items-center justify-center w-11 h-11 rounded-full bg-background-50 text-primary-500 shrink-0">
                    <i className={`${h.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading font-bold text-base text-foreground-950">{h.title}</h3>
                    <p className="mt-1 text-sm text-foreground-600">{h.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px overflow-hidden rounded-lg bg-background-300">
          {stats.map((s) => (
            <div key={s.label} className="bg-background-100 px-5 py-8 md:px-7 md:py-10">
              <p className="font-heading font-extrabold text-2xl md:text-3xl text-accent-600 leading-tight">
                {s.value}
              </p>
              <p className="mt-2 font-label text-[11px] tracking-[0.16em] uppercase text-foreground-600">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}